import { NextPage } from 'next';
import { GetStaticProps, GetStaticPaths } from 'next';
import Rating from '@/components/screens/rating/Rating';
import { BOOKS_FOR_PAGE, PRERENDER_PAGES, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import useRedirectToFirstPage from '@/hooks/useRedirectToFirstPage';
import { getPagesNumbersPaths } from '@/helpers/helpers';
import { IBooksPage } from '@/interfaces/booksPage.interface';

const RatingPageDynamic: NextPage<IBooksPage> = ({ books }) => {
  useRedirectToFirstPage('/rating/books/');

  return <Rating books={books} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;

  const res = await fetch(`${API_URL}satellite/books/rating?page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default RatingPageDynamic;
